// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"72":"2d43462b","151":"963fb455","398":"6413e468","418":"3e8fbedc"}[chunkId] + ".chunk.js";
};